import { gql } from '@apollo/client';
import { Link, StatusBadge, Tooltip } from '@apollo/orbit';
import moment from 'moment';
import React from 'react';
import { useLocation } from 'react-router-dom-v5-compat';

import { format } from 'src/lib/format';
import { GraphQLTypes } from 'src/lib/graphqlTypes';

import {
  TaskStatusIcon,
  TaskStatusIconTaskFragment,
} from '../checksPage/taskStatusIcon/TaskStatusIcon';
import { useInternalGraphLinking } from '../hooks/useInternalGraphLinking';

import { taskTypeDisplayValue } from './CheckTask/CheckTasks';
import { taskToTaskType } from './CheckTask/taskToTaskType';

export const TaskStatusBarTaskFragment = gql`
  fragment TaskStatusBarTaskFragment on CheckWorkflowTask {
    id
    createdAt
    completedAt
    ...TaskStatusIconTaskFragment
  }
  ${TaskStatusIconTaskFragment}
`;

export function TaskStatusBar({
  tasks,
}: {
  tasks: GraphQLTypes.TaskStatusBarTaskFragment[];
}) {
  const location = useLocation();
  const { currentCheckTasksRoute, currentCheckRoute } =
    useInternalGraphLinking();
  return (
    <div className="flex flex-wrap gap-2">
      {tasks.map((task) => {
        const taskDuration =
          task.completedAt &&
          task.createdAt &&
          moment.duration(moment(task.completedAt).diff(task.createdAt));

        const taskType = taskToTaskType(task);
        const statusBadge = (
          <Tooltip
            isDisabled={!taskDuration}
            label={taskDuration && `Duration: ${format.duration(taskDuration)}`}
          >
            <StatusBadge
              key={task.id}
              icon={<TaskStatusIcon task={task} allowMultipleStatuses={true} />}
            >
              {taskTypeDisplayValue(taskToTaskType(task))}
            </StatusBadge>
          </Tooltip>
        );
        if (
          taskType === 'unknown' ||
          task.status === GraphQLTypes.CheckWorkflowTaskStatus.BLOCKED ||
          task.status === GraphQLTypes.CheckWorkflowTaskStatus.PENDING
        ) {
          return statusBadge;
        } else {
          return (
            <Link
              key={task.id}
              to={currentCheckTasksRoute.locationFrom({
                location,
                fromRouteConfig: currentCheckRoute,
                patch: { taskType },
              })}
              className="group font-normal"
            >
              {statusBadge}
            </Link>
          );
        }
      })}
    </div>
  );
}
